import { useBreakpoints } from '../../../providers/BreakpointProvider'
import { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { FreeMode, Navigation, Thumbs } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { getImage } from '../../../../api/images/images'

const ProductGallery = ({ images }: { images: string[] }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null)
  const { breakpoints } = useBreakpoints()

  const [ imagesSrc, setImageSrc ] = useState<string[] | null>(null);
    // no estoy seguro si useEffect es necesario aqui porque tecnicamente el imageUrl no cambia
     useEffect(() => {
        const fetchImage = async () => {
          const blobs = await Promise.all(images.map((imageId) => getImage(imageId)));
          setImageSrc(blobs);
        };
    
        if (images.length) {
          fetchImage();
        }
        
      }, [images])

  return (
    <Row className="mb-3 g-3">
      <Col xs={12} md={2} lg={12} xl={2}>
        <Swiper
          direction={
            breakpoints.down('md') ||
            (breakpoints.up('lg') && breakpoints.down('xl'))
              ? 'horizontal'
              : 'vertical'
          }
          onInit={setThumbsSwiper}
          loop={false}
          spaceBetween={16}
          slidesPerView={4}
          freeMode={true}
          watchSlidesProgress={true}
          modules={[Thumbs]}
        >
          {imagesSrc?.length && imagesSrc.map((image, index) => (
            <SwiperSlide className="h-auto" key={index}>
              <div className="product-thumb-container">
                <img src={image} alt="" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Col>
      <Col xs={12} md={10} lg={12} xl={10}>
        <div className="d-flex rounded-3">
          <Swiper
            loop={false}
            spaceBetween={10}
            thumbs={{
              swiper:
                thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
            }}
            modules={[FreeMode, Navigation, Thumbs]}
          >
            {imagesSrc?.length && imagesSrc.map((image, index) => (
              <SwiperSlide key={index} className='product-photo'>
                <img src={image} className="w-100 rounded-3" />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Col>
    </Row>
  )
}

export default ProductGallery
